import PropTypes from 'prop-types'
import React from 'react'

import SimpleModal from '../../common/SimpleModal'

const BuyHelpFinancement = ({ helper, show }) => (
  <SimpleModal
    onClose={helper}
    show={show}
    title={
      <h3>
        <strong>
          Richiedi il tuo finanziamento
          <br />
          in pochi click!
        </strong>
      </h3>
    }
  >
    <div className="helpguide__content">
      <h4 className="helpguide__subtitle">
        <span className="hghlght animate">Solo poche semplici regole</span>
      </h4>
      <ol className="numbers-list helpguide__list">
        <li>
          <strong>Devi essere residente in Italia</strong>, per acquistare (e
          intestarti) un’auto da brumbrum.
        </li>
        <li>
          <strong>
            Devi avere tra i 18 e i 70 anni e percepire un reddito dimostrabile
            tramite un documento di reddito
          </strong>
          , per poter avviare una richiesta di finanziamento.
        </li>
        <li>
          <strong>
            Solo il futuro intestatario dell’auto e del conto corrente sul quale
            verranno addebitate le rate
          </strong>{' '}
          può avviare una richiesta di finanziamento.
        </li>
      </ol>

      <h4 className="helpguide__subtitle">
        <span className="hghlght animate">Quali documenti occorrono?</span>
      </h4>
      <p>
        Prepara e tieni a portata di mano i seguenti documenti, assicurandoti
        che siano tutti in corso di validità:
      </p>
      <ol className="dots-list helpguide__list">
        <li>
          Documento d’identità (uno a scelta tra carta d’identità, passaporto o
          patente).
        </li>
        <li>Codice fiscale.</li>
        <li>
          Giustificativo di reddito:
          <ul className="alphabet-list">
            <li>
              Dipendenti: l’ultima busta paga disponibile (e, dove possibile,
              non più vecchia del mese precedente al momento in cui è avviata la
              richiesta di finanziamento).
            </li>
            <li>
              Lavoratori autonomi: l’ultimo modello UNICO disponibile e la
              ricevuta dell’avvenuta presentazione telematica.
            </li>
            <li>
              Pensionati: libretto/cedolino/certificato di pensione rilasciato
              dall’ente pensionistico.
            </li>
          </ul>
        </li>
      </ol>
      <p>
        Se la residenza dichiarata durante la compilazione non è indicata o non
        corrisponde all’indirizzo indicato sul documento, si richiede:
      </p>
      <ol className="dots-list helpguide__list">
        <li>
          Certificazione di residenza (uno a scelta tra: utenza domestica
          intestata al richiedente o apposita documentazione rilasciata dal
          Comune negli ultimi 90 giorni; in via eccezionale possono essere
          accettati anche tessera elettorale o libretto di circolazione di un
          altro veicolo riportante l’attuale residenza)
        </li>
      </ol>
      <p>Se sei cittadino extra EU:</p>
      <ol className="dots-list  helpguide__list">
        <li>Permesso di soggiorno.</li>
        <li>Passaporto (solo se non fornito come documento d’identità).</li>
      </ol>

      <h4 className="helpguide__subtitle">
        <span className="hghlght animate">Cosa devi fare?</span>
      </h4>
      <p>
        Inserisci i dati richiesti (anagrafici, residenza, ecc.) sul sito. Di
        seguito alcune precisazioni che possono esserti utili:
      </p>

      <h5 className="helpguide__subtitle__small">
        <strong>Persona politicamente esposta</strong>
      </h5>
      <p>
        Si intendono tutte le persone che occupano o hanno occupato importanti
        cariche pubbliche (ad esempio: Capi di Stato, Ministri, corti supreme e
        costituzionali, ambasciatori, membri degli organi amministrativi).
        Rientrano nella categoria i familiari (coniuge, figli e i loro coniugi,
        conviventi negli ultimi cinque anni e i genitori) e le persone che
        intrattengono stretti legami con i soggetti politicamente esposti (ad
        esempio: stretta relazione d’affari)
      </p>

      <h5 className="helpguide__subtitle__small">
        <strong>Documento d'identità</strong>
      </h5>
      <p>Luogo di rilascio:</p>
      <ol className="dots-list helpguide__list">
        <li>Carta d’identità: indicare Comune riportato sul documento.</li>
        <li>
          Passaporto: indicare il Comune della Questura che lo ha rilasciato o
          lo Stato estero; se non indicato, è sufficiente indicare il proprio
          Comune di Residenza.
        </li>
        <li>
          Patente: indicare il Comune della Motorizzazione Civile che lo ha
          rilasciato, solitamente indicato tramite sigla della provincia nel
          campo “4c” del documento; se è riportato U.C.O. indicare Roma
        </li>
      </ol>

      <h5 className="helpguide__subtitle__small">
        <strong>Residenza e domicilio</strong>
      </h5>
      <p>
        Inserisci la data di inizio residenza presso l’indirizzo specificato,
        cercando di indicare il periodo preciso.
      </p>
      <p>
        Nel caso risultassi residente nel luogo indicato da meno di tre anni, ti
        verrà chiesto di indicare il tuo precedente indirizzo di residenza.
      </p>

      <h5 className="helpguide__subtitle__small">
        <strong>Membri del nucleo familiare</strong>
      </h5>
      <p>
        I membri del nucleo familiare comprendono il coniuge, i figli minori e
        maggiorenni (solo se risultano a carico), i minori in affido, le persone
        a carico ai fini Irpef anche se non presenti nello stato di famiglia.
      </p>

      <h5 className="helpguide__subtitle__small">
        <strong>Conto Corrente</strong>
      </h5>
      <ol className="numbers-list helpguide__list">
        <li>
          Inserisci una data il più possibile precisa circa l’apertura del conto
          corrente.
        </li>
        <li>
          Inserisci l’IBAN sul quale desideri vengano addebitate le rate del
          finanziamento.
          <br />
          <strong>
            Ricorda che l’intestatario del conto dovrà obbligatoriamente essere
            il richiedente del finanziamento!
          </strong>
        </li>
      </ol>

      <h4 className="helpguide__subtitle">
        In caso di dubbi o se hai bisogno di aiuto non esitare a contattare il
        Servizio Clienti brumbrum al numero{' '}
        <span className="hghlght animate">02.800.29</span>!<br />
        Il nostro team è sempre pronto a rispondere ad ogni tua richiesta dal
        lunedì al venerdì dalle 9:00 alle 19:00 e il sabato dalle 9:00 alle
        18:00.
      </h4>
    </div>
  </SimpleModal>
)

BuyHelpFinancement.propTypes = {
  helper: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
}

export default BuyHelpFinancement
